/***
 *
 *   USER
 *   shows the current user
 *   if user belongs to more than one account they can switch accounts here
 *
 **********/

import React, { useContext, useState, useEffect, useRef, Suspense } from 'react';
import {
  AuthContext,
  // ViewContext,
  // HoverNav,
  Dropdown,
  Button,
  TextInput,
  WhitelabelContext,
} from 'components/lib';
import { useCopilotContext } from 'components/copilot/CopilotContext';
import { CopilotBoltIcon } from 'components/copilot/CopilotBoltIcon';

import { useNavigate } from 'react-router-dom';
import axios from 'axios';
// import Style from './user.tailwind.js';
import {
  UilUser,
  UilHeart,
  UilAngleDown,
  UilQuestionCircle,
  UilCog,
  UilBoltAlt,
  UilUsdCircle,
  UilSignOutAlt,
  UilBuilding,
  UilGift,
  UilEnvelopeCheck,
  UilEnvelope,
  UilFire
} from '@iconscout/react-unicons';
import './user.scss';
import { Tooltip } from 'react-tooltip';
import Swal from 'sweetalert2';
// import { actions } from 'react-table';
import CustomDialog from 'components/custom/customDialog.js';
import { setWorkspaceLocalStorage } from 'utils/setWorkspaceLocalStorage.js';

const NovuNotification = React.lazy(() => import('components/notification/novunotification').then(m => ({ default: m.NovuNotification })));

const Toast = Swal.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 3000,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.addEventListener('mouseenter', Swal.stopTimer);
    toast.addEventListener('mouseleave', Swal.resumeTimer);
  },
});

export function User(props) {
  let navigator = useNavigate();
  const authContext = useContext(AuthContext);
  // const viewContext = useContext(ViewContext);
  const [plan, setPlan] = useState(null);
  const accountName = authContext.user?.accounts?.find(
    (x) => x.id === authContext.user?.account_id
  )?.name;
  const [showChangeLog, setChangeLog] = useState(false)
  const [isWorkspaceDialogOpen, setIsWorkspaceDialogOpen] = useState(false);
  const [workspaceName, setWorkspaceName] = useState('');
  const ref = useRef(null);
  const workspace_ref = useRef(null);
  const { isWhiteLabelled, whitelabelDetails } = useContext(WhitelabelContext);
  const agencyName = whitelabelDetails?.agencyName || 'SalesBlink';
  const hideRewardsAndUpdates = isWhiteLabelled && whitelabelDetails?.hideRewardsAndUpdates && authContext?.user?.permission !== 'owner';
  const { openPanel } = useCopilotContext();

  const getCurrentPlan = async () => {
    try {
      let result = await axios.get(`/api/active-plan-usage`);
      // console.log("DATA ", result.data.data)

      if (result.data.data) setPlan(result.data.data);
    } catch (err) {
      // console.log("Error in creating sequence ", err)
    }
  };

  useEffect(() => {
    setTimeout(() => {
      setChangeLog(true)
    }, 5000)
  }, [])

  useEffect(() => {
    getCurrentPlan();
  }, []);

  const handleWorkspace = async () => {
    if(workspaceName.trim().length < 4) return Toast.fire({ icon: 'error', title: `The workspace name must be at least four characters long.` });
    try {
      const response = await axios.post('/api/account/workspaces', {workspaceName: workspaceName});
      if(response.status === 201) {
        setWorkspaceLocalStorage(workspaceName);
        authContext.switchAccount(response.data.data.id);
      }
    } catch (error) {
      Swal.fire({
        icon: 'info',
        title: 'Can not create workspace',
        html: error.response.data.message,
        showCancelButton: true,
        confirmButtonText: `Upgrade`,
        confirmButtonColor: '#0066FF',
        reverseButtons: true
      }).then((result) => {
        if(result.isConfirmed) window.location.href = '/account/billing';
      });
    } finally {
      setWorkspaceName('');
      setIsWorkspaceDialogOpen(false);
    }
  }

  return (
    <div
      className="userContainer"
      style={{
        marginLeft: 'auto',
        display: 'flex',
      }}
    >
      {plan?.name === 'Trial' && plan?.emailSendLimit?.limit > 0 && (
        <div className="trial">
          <div className='trial-face'>
            Trial Limits
            <div>
              <UilAngleDown />
            </div>
          </div>
          <div className="trial-dropdown">
            <div className="trial-row">
              <UilEnvelopeCheck size={16} />
              <span className="trial-text">Email Sends {`(${plan.emailSendLimit?.used || 0}/${plan.emailSendLimit?.limit})`}</span>
            </div>
            <div className="trial-row">
              <UilEnvelope size={16} />
              <span className="trial-text">Email Senders {`(${plan.senderCount?.used || 0}/Unlimited)`}</span>
            </div>
            <div className="trial-row">
              <UilFire size={16} />
              <span className="trial-text">Email WarmUp {`(${plan.warmUpCount?.used || 0}/Unlimited)`}</span>
            </div>
            <Button
              variant="primary"
              text={`Subscribe Now`}
              action={() => navigator('/account/billing?type=upgrade')}
            />
          </div>
        </div>
      )}
      {isWorkspaceDialogOpen && 
        <CustomDialog close={true} width={500} onClose={() => setIsWorkspaceDialogOpen(false)}>
          <div style={{ padding: 10 }} id="deleteSenderModal">
            <h1
              className="text-2xl text-modal-header"
              style={{ marginTop: '-15px', padding: 0 }}
            >
              New Workspace
            </h1>
            <p className="text-modal-description" style={{ padding: 0 }}>
              Create a new workspace.
            </p>
            <hr className="mt-3 mb-3" />
            <TextInput 
              value={workspaceName}
              onChange={(name, value) => setWorkspaceName(value)}
              placeholder="Enter the name of your workspace"
            />
            <div
              style={{
                display: 'flex',
                marginTop: '1rem',
                gap: '2rem',
                justifyContent: 'end',
                width: '100%',
              }}
            >
              <Button
                variant="primary grey"
                action={() => {
                  setWorkspaceName('');
                  setIsWorkspaceDialogOpen(false);
                }}
                text="Cancel"
              />
              <Button
                variant="primary"
                action={handleWorkspace}
                text={`Create`}
              />
            </div>
          </div>
        </CustomDialog>
      }
      {authContext.user?.accounts?.length >= 1 && (
        <div style={{ marginTop: 3 }}>
          <Dropdown 
            label={accountName}
            variant="secondary"
            icon={<UilBuilding />}
            openDialog={setIsWorkspaceDialogOpen}
            fromWorkspace={true}
            defaultAction={() => {workspace_ref?.current?.close()}}
            items={[]}
            id='workspace-dropdown-button'
          />
          <Tooltip ref={workspace_ref} anchorSelect='#workspace-dropdown-button' place='bottom'>{accountName}</Tooltip>
        </div>
      )}

      <div className="dropdownBtn" style={{ margin: 'auto', marginRight: 16, position: 'relative', marginTop: 3 }} id='copilot-dropdown'>
        <button
          className="dropdown-button secondary"
          onClick={() => openPanel()}
        >
          <div><CopilotBoltIcon className="copilot-bolt-icon" /></div>
        </button>
      </div>
      <Tooltip ref={ref} anchorSelect={`#copilot-dropdown`} place="bottom">Chat with {agencyName} AI</Tooltip>

      {authContext?.user?.permission !== 'client' && <>
        {!hideRewardsAndUpdates && <>
          <div 
            className='rewards_icon cursor-pointer' 
            onClick={() => navigator('/rewards')}
            id="rewards-icon"
            style={{ marginTop: 16, marginRight: 4 }}
          >
            <UilGift />
          </div>
          <Tooltip anchorSelect='#rewards-icon' place='bottom'>Earn Rewards</Tooltip>

          <div className='change_log cursor-pointer' >
            {showChangeLog && <UilBoltAlt />}
          </div>
        </>}

        <Suspense fallback={null}>
          <NovuNotification
            userID={authContext?.user?.userId}
          />
        </Suspense>
      </>}

      {/* <NotificationMenu
        onAction={(action, id) => {
          console.log("ACTION ", action, id)
        }}
        items={[
          // { id: "1", title: "First Sample Notification", desc: "This is an example for a sample notification", read: true, time: "30m" },
          // { id: "2", title: "Second Sample Notification", desc: "This is an example for a sample notification", read: false, time: "30m" },
          // { id: "3", title: "Third Sample Notification", desc: "This is an example for a sample notification", read: true, time: "30m" },
          // { id: "4", title: "Fourth Sample Notification", desc: "This is an example for a sample notification", read: true, time: "30m" },
          // { id: "5", title: "Fifth Sample Notification", desc: "This is an example for a sample notification", read: true, time: "30m" },
        ]} >
      </NotificationMenu> */}

      <Dropdown
        icon={<UilUser />}
        // label={authContext.user?.name}
        style={{ marginTop: '7px' }}
        defaultAction={() => { }}
        fromUser={true}
        items={[
          {
            title: authContext.user?.name, 
            action: () => {
              window.location.href = "../../account/profile"
            },
            icon: <UilUser />
          },
          ...(authContext?.user?.permission !== 'client' ? [
            {
              title: 'Integrations',
              action: () => {
                window.location.href = '/account/integration';
              },
              icon: <UilBoltAlt />
            }
          ] : []),
          ...(authContext?.user?.permission !== 'client' && authContext?.user?.permission !== 'user' ? 
            [
              {
                title: 'Billing',
                action: () => {
                  window.location.href = '/account/billing';
                },
                icon: <UilUsdCircle />
              }
            ] : []),
            {
              title: 'Other Settings',
              action: () => {
                window.location.href = '/account/settings';
              },
              icon: <UilCog />
            },
          ...(!isWhiteLabelled || (isWhiteLabelled && authContext?.user?.permission === 'owner') ? [{
            title: 'Affiliates',
            action: () => {
              window.open('https://affiliate.salesblink.io/program', '_blank');
            },
            icon: <UilHeart />
          }] : []),
          // ...(authContext?.user?.permission !== 'client' ? [{
          //   title: "Support",
          //   action: () => {
          //     const openEvent = new Event("crisp:openWidget");
          //     document.dispatchEvent(openEvent);
          //     window.dispatchEvent(openEvent);
          //   },
          //   icon: <UilLifeRing />
          // }] : []),
          ...(authContext?.user?.permission !== 'client' ? [{
            title: 'Help',
            action: () => {
              window.open('https://help.salesblink.io', '_blank');
            },
            icon: <UilQuestionCircle />
          }] : []),
          { type: 'separator' },
          {
            title: 'Sign Out',
            action: () => {
              authContext.signout();
            },
            icon: <UilSignOutAlt />
          },
        ]}
        align="right"
      />
    </div>
  );
}
